import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Spacer, Text } from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import numberUtils from 'app/shared/utils/numberUtils';
import ClaimActions from 'app/shared/actions/ClaimActions';
import ClaimListingCard from 'app/shared/components/ClaimListingCard';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

const { formatPhoneNumberInput } = numberUtils;

const propTypes = {
    contactToDelete: PropTypes.shape({
        value: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
};

const DeleteClaimContact = ({ contactToDelete: { value, type } }) => {
    const dispatch = useDispatch();
    const [associatedListings, setAssociatedListings] = useState([]);
    const [loadingListings, setLoadingListings] = useState(true);
    const [hasError, setHasError] = useState(false);

    const contactType = isNaN(parseInt(value, 10)) ? 'email' : 'phone';
    const formattedContactMethod = contactType === 'email' ? value : formatPhoneNumberInput(value);
    const subHeadingText = associatedListings.length > 0 ?
        'the following listings will be removed. We will also ' :
        'we will ';

    const getAssociatedListings = () => {
        setLoadingListings(true);
        dispatch(ClaimActions.getExclusiveProperties(contactType, value))
            .then(response => setAssociatedListings(response.listings))
            .catch(() => setHasError(true))
            .finally(() => setLoadingListings(false));
    };

    useEffect(() => {
        getAssociatedListings();
    }, []);

    return (
        <div className="DeleteClaimContact">
            <Spacer marginBottom="md">
                <Center>
                    <Text fontType="bodyHeading">
                        {`Are you sure you want to remove ${formattedContactMethod}?`}
                    </Text>
                </Center>
                <Spacer marginY="sm" />
                <Center>
                    <Text>
                        {
                            `By removing this contact method, ${subHeadingText}
                            not be able to inform you of new listings that match the contact.`
                        }
                    </Text>
                </Center>
            </Spacer>
            {loadingListings
                ? <SpinnerContainer />
                : (
                    <>
                        {associatedListings.map(listing => (
                            <ClaimListingCard
                                key={`${listing.listingAlias}`}
                                listingData={listing}
                                highlightPhone={type === 'phone'}
                                highlightEmail={type === 'email'}
                            />
                        ))}
                        {hasError && (
                            <Center fontColor="red600">
                                {ErrorMessageConstants.DEFAULT_ERROR}
                            </Center>
                        )}
                    </>
                )
            }
        </div>
    );
};

DeleteClaimContact.propTypes = propTypes;

export default DeleteClaimContact;
